var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundsAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67506",
    "data-name": "Group 67506",
    transform: "translate(-332 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22412",
    "data-name": "Rectangle 22412",
    width: 72,
    height: 72,
    transform: "translate(332 756)",
    fill: "#ddf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-physics",
    transform: "translate(347.951 771.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67457",
    "data-name": "Group 67457",
    transform: "translate(0.05 0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67456",
    "data-name": "Group 67456",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80508",
    "data-name": "Path 80508",
    d: "M37.655,2.45C33.7-1.507,27.789-.542,20.048,5.283,12.309-.542,6.4-1.509,2.441,2.45S-.551,12.316,5.275,20.056C-.551,27.8-1.518,33.7,2.441,37.663a7.834,7.834,0,0,0,5.737,2.4c3.285,0,7.252-1.754,11.87-5.227,4.615,3.474,8.583,5.227,11.87,5.227a7.834,7.834,0,0,0,5.737-2.4c3.959-3.959,3-9.866-2.834-17.607,5.826-7.741,6.792-13.648,2.834-17.607Zm-5.8.985A4.677,4.677,0,0,1,35.3,4.8c2.91,2.912.76,7.856-2.647,12.566-1.4-1.647-2.97-3.359-4.764-5.154s-3.51-3.369-5.157-4.767C25.9,5.157,29.169,3.435,31.857,3.435Zm-1.29,16.622c-1.685,2.034-3.47,3.935-5.027,5.5s-3.459,3.334-5.492,5.019c-2.034-1.685-3.935-3.47-5.492-5.019s-3.342-3.467-5.027-5.5c1.685-2.034,3.47-3.937,5.027-5.492s3.459-3.342,5.492-5.029A83.082,83.082,0,0,1,30.567,20.056ZM4.793,4.8A4.667,4.667,0,0,1,8.238,3.435c2.689,0,5.959,1.722,9.123,4.01-1.647,1.4-3.36,2.972-5.157,4.767s-3.367,3.5-4.765,5.154C4.033,12.656,1.879,7.712,4.793,4.8Zm0,30.5c-2.91-2.91-.76-7.856,2.645-12.565,1.4,1.647,2.972,3.359,4.765,5.154s3.5,3.372,5.149,4.769c-4.709,3.41-9.653,5.562-12.56,2.649Zm30.5,0c-2.909,2.907-7.851.762-12.56-2.642,1.643-1.4,3.357-2.979,5.149-4.769s3.367-3.5,4.764-5.154c3.414,4.717,5.567,9.661,2.654,12.571Z",
    transform: "translate(-0.05 -0.059)",
    fill: "#1d98b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 3.334,
    cy: 3.334,
    r: 3.334,
    transform: "translate(16.664 16.664)",
    fill: "#1d98b5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundsAvailable);
export default __webpack_public_path__ + "static/media/funds-available.22184dc6ec9b62d2caef5fb7fdbb7842.svg";
export { ForwardRef as ReactComponent };